/**
 * ButtonGroup.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import { WHITE, BLACK } from 'root/theme';
import {
  ButtonGroupContainer,
  ButtonComponent,
} from './ButtonGroup.styles';

/**
 * Renders a group of buttons.
 *
 */
export class ButtonGroup extends Component {
  render() {
    const { buttons, onSelect, className, color, ...rest } = this.props;

    const buttonGroup = buttons.map((b) => {
      return (
        <ButtonComponent
          key={b.label}
          onClick={onSelect || null}
          value={b.value}
          name={b.label}
          color={b.selected ? WHITE : BLACK}
          background={b.selected ? color : WHITE}
          {...rest}
        >
          {b.label}
        </ButtonComponent>
      );
    });

    return (
      <ButtonGroupContainer className={className || ``} {...rest}>
        {buttonGroup}
      </ButtonGroupContainer>
    );
  }
}

export default ButtonGroup;
